let hasCalled = false

var get_ios_function = function (name, data, callback) {
    connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(name, data, function (response) {
            if (callback !== '') {
                callback(response);
            }
        });
        if (!hasCalled && bridge.init) {
            bridge.init(function (message, responseCallback) {});
            hasCalled = true
        }
    });
}

var connectWebViewJavascriptBridge = function (callback) {
    // 旧版 bridge 连接逻辑
    // console.log('connectJSBridge')
    // if (window.WebViewJavascriptBridge) {
    //     callback(window.WebViewJavascriptBridge)
    // } else {
    //     document.addEventListener('WebViewJavascriptBridgeReady', function () {
    //         callback(window.WebViewJavascriptBridge)
    //     }, false)
    // }

    if (window.WebViewJavascriptBridge) { 
        // console.log('444') 暂且注视
        return callback(window.WebViewJavascriptBridge); 
    }else {
        setTimeout(function () {
            connectWebViewJavascriptBridge(callback)
        }, 300)
    }
    if (window.WVJBCallbacks) { 
        // console.log('555') 暂且注视
        return window.WVJBCallbacks.push(callback); 
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() { 
        document.documentElement.removeChild(WVJBIframe) 
    }, 0)
    // console.log('666') 暂且注视
}

export default {
    get_ios_function: get_ios_function
}